module.exports = __webpack_public_path__ + "img/garantie-soins-courants.c56d8347.svg";